import axios from "axios";
import toast from "react-hot-toast";

const AddImage = async (uploadedImage) => {
  const formData = new FormData();
  formData.append("image", uploadedImage);
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  try {
    const response = await axios.post(`${BASE_URL}/file/add`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    toast.success("Added Successfully!");
    return response.data?.data?.location || null;
  } catch (error) {
    toast.error("Image upload failed: " + (error.response?.data?.message || "Server error"));
    return null;
  }
};

export const AddImageAll = async (uploadedImage) => {
  const formData = new FormData();
  formData.append("image", uploadedImage);
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  try {
    const response = await axios.post(`${BASE_URL}/file/addAll`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    toast.success("Added Successfully!");
    return response.data?.data?.location || null;
  } catch (error) {
    toast.error("Image upload failed: " + (error.response?.data?.message || "Server error"));
    return null;
  }
};

export default AddImage;
